import { useState } from "react";
import { FileText, ListChecks, BarChart3, CreditCard } from "lucide-react";

import { FiscalLock } from "./FiscalGate";
import CatalogoFiscal from "./components/CatalogoFiscal";
import FormasPagamentoFiscal from "./components/FormasPagamentoFiscal";
import ResultadosFiscais from "./components/ResultadosFiscais";

/**
 * FINANCEIRO → Módulo Fiscal.
 *
 * - RESULTADOS: quanto foi emitido, comparado ano a ano.
 * - CATÁLOGO: classifica os produtos (NCM, CFOP, origem, CST/CSOSN).
 * - FORMAS DE PAGAMENTO: o switch que decide quem emite (regra do dono).
 *
 * A CONEXÃO com o provedor fiscal NÃO vive aqui: ela fica em Configurações →
 * Sistema → Integração, no card "NFe Fácil", junto das outras integrações.
 * Decisão do dono: um lugar só pra conectar qualquer serviço externo.
 */

const ABAS = [
  { key: "resultados", label: "Resultados", icon: BarChart3 },
  { key: "catalogo", label: "Catálogo fiscal", icon: ListChecks },
  { key: "formas", label: "Formas de pagamento", icon: CreditCard },
];

export default function FiscalPage() {
  const [aba, setAba] = useState("resultados");

  return (
    <div className="p-4 sm:p-6 max-w-5xl mx-auto space-y-5">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <FileText className="w-6 h-6 text-primary" />
          <h1 className="text-2xl sm:text-3xl font-bold">Módulo Fiscal</h1>
        </div>
        <p className="text-muted-foreground text-sm">
          Nota fiscal do consumidor (NFC-e) emitida direto da venda. A conexão fica em{" "}
          <span className="font-medium text-foreground">
            Configurações → Sistema → Integração → NFe Fácil
          </span>.
        </p>
      </div>

      <div className="flex gap-1 bg-muted/50 rounded-xl p-1 w-fit max-w-full overflow-x-auto">
        {ABAS.map((a) => {
          const Icon = a.icon;
          const ativa = aba === a.key;
          return (
            <button
              key={a.key}
              type="button"
              onClick={() => setAba(a.key)}
              className={`flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg whitespace-nowrap transition-all ${
                ativa
                  ? "bg-background text-foreground shadow-sm border border-border/50"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              <Icon className={`w-4 h-4 ${ativa ? "text-primary" : ""}`} />
              {a.label}
            </button>
          );
        })}
      </div>

      <FiscalLock>
        {aba === "resultados" && <ResultadosFiscais />}
        {aba === "catalogo" && <CatalogoFiscal />}
        {aba === "formas" && <FormasPagamentoFiscal />}
      </FiscalLock>
    </div>
  );
}
